export default __webpack_public_path__ + "static/media/photo--sm--64.fe6e0dfa.jpg";